import * as actions from '../api';

// NOTE: this middleware MUST stay synchronous (no `async` on the outer function). An async Redux
// middleware Promise-wraps the result of every `next(action)`, which breaks RTK Query's synchronous
// internal dispatch (`subscriptionSelectorsRef.current.isRequestSubscribed is not a function`).
// The async request work is therefore isolated in a detached IIFE, while the middleware itself
// returns `next(action)` synchronously in both branches.
// See https://github.com/reduxjs/redux-toolkit/issues/4257
const api =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (action.type !== actions.apiCallBegan.type) {
      return next(action);
    }

    const { request, onStart, onSuccess, onError } = action.payload;

    if (onStart) {
      dispatch({ type: onStart });
    }
    const result = next(action);

    (async () => {
      try {
        const response = await request();
        dispatch(actions.apiCallSuccess(response.data));

        if (onSuccess) {
          dispatch({ type: onSuccess, payload: response.data });
        }
      } catch (error) {
        dispatch(actions.apiCallFailed(error.message));

        if (onError) {
          dispatch({ type: onError, payload: error.message });
        }
      }
    })();

    return result;
  };

export default api;
